<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> Recherche CCAM </div>
        <div class="modal-body">
            <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" *ngIf="formGroup">
                <div class="inputs">
                    <frg-form-input label="Code" id="code" type="text" placeholder="Ex: QBFA003" [formGroup]="formGroup"
                        [control]="formGroup.get('code')"></frg-form-input>
                    <frg-form-input label="Nom" id="nom" type="text" [formGroup]="formGroup"
                        [control]="formGroup.get('nom')"></frg-form-input>
                </div>
                <div class="inputs-submit">
                    <frg-form-input label="Catégories" id="categories" type="ngSelect" [formGroup]="formGroup"
                        [control]="formGroup.get('categories')" [selectValue]="categoriesList"
                        [isClearableSelect]="true">
                    </frg-form-input>
                    <frg-button [disabled]="!formGroup.valid" [type]="'submit'" [backgroundColor]="'var(--primary)'">
                        Rechercher</frg-button>
                </div>
            </form>
            <div class="tables">
                <frg-table #table1 [keysBody]="listCCAMBodyTable" [keysColumn]="listCCAMColumnTable"
                    [isRowsClickable]="true" (onDblClickRow)="selectUnseclectCode($event)" [isOkForDblClick]="true"
                    tableButton1="assets/icons/star-grey.svg" (onClick1)="addToFavorisCcam($event)"
                    (onChangePage)="onChangePage($event)">
                </frg-table>
                <frg-table #table2 [keysBody]="CCAMDetailsBodyTable" [keysColumn]="CCAMDetailsColumnTable"
                    class='reduce'>
                </frg-table>
                <div class="buttons-wrapper">
                    <frg-button [type]="'button'" [backgroundColor]="'var(--darkest-primary)'"
                        (activated)="closeCCAMModal()">Annuler</frg-button>
                    <frg-button [type]="'button'" (click)="codeSelected()">Sélectionner</frg-button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>